module.exports = __webpack_public_path__ + "img/pesquisa.a44d4486.png";